export default "__VITE_ASSET__1f8de3fd__"